import MainNavbarContainer from './MainNavbar.container';

export default MainNavbarContainer;
